import React, { Component } from 'react';
//import {getIcon, getModeIcon, isEmpty} from '../../Common/Common';
//import temp from '../../../Images/Daikin_Images/icon/temp.png';
import room_temp from '../../../Images/Cell_Status_Icon/Room_Temp/thermo.png';

export default class Display_Mp_Cell_Temp extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let temp_img_width = (0.1) * this.props.cell_width;
		let font_size = (0.1) * this.props.cell_width;

		let pointInfo = this.props.point_info;

		let tempValue = null;

		if (pointInfo.hasOwnProperty('temp')) {
			tempValue = pointInfo.temp;
		}

		return (
			<div style={{ display: tempValue == null ? 'none' : 'inline-block', whiteSpace: 'nowrap' }}>
				<img src={room_temp} style={{ width: temp_img_width, display: 'inline-block' }} />
				{/* <span style={{fontSize: font_size, fontColor: 'red'}}>{pointInfo.temp}</span> */}
				<span style={{ fontSize: font_size }}>{tempValue + this.props.receiver.getString('DEG')}</span>
			</div>
		)
	}
}